<template>
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    :data-target="'#'+target"
    :aria-controls="target"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <i class="fa fa-bars icon-navbar"></i>
  </button>
</template>
<script>
export default {
  props: {
    target: {
      type: [String, Number],
      description: "Button target element",
    },
    toggled: {
      type: Boolean,
      default: false,
      description: "Whether button is toggled",
    },
  },
};
</script>
<style>
</style>
